import type { ReactNode } from "react";

// 원본(MUI styled) Pref.jsx 의 레이아웃을 Tailwind 로 재구성:
// - 1000px 이상: 좌측 라벨 셀(flex: 1 0 40%) / 우측 컨트롤 셀(flex: 1 0 calc(60% - 50px)) 2단 행
// - 1000px 미만: 세로 스택(gap 10px)
// - alignTop 이 아니면 셀 내용을 세로 중앙 정렬

interface PrefGroupProps {
  children?: ReactNode;
}

interface PrefProps {
  labelId?: string;
  alignTop?: boolean;
  /** 대부분 문자열이지만 Account 화면에서는 아이콘이 섞인 노드를 넘긴다 */
  title: ReactNode;
  subtitle?: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
}

export const PrefGroup = (props: PrefGroupProps) => (
  <div role="table" className="flex flex-col gap-5">
    {props.children}
  </div>
);

export const Pref = (props: PrefProps) => {
  const cellClass = `flex min-w-0 flex-col ${props.alignTop ? "" : "justify-center"}`;
  return (
    <div role="row" className="flex flex-col gap-2.5 min-[1000px]:flex-row min-[1000px]:gap-0">
      <div role="cell" id={props.labelId ?? ""} aria-label={props.title as string} className={`${cellClass} min-[1000px]:flex-[1_0_40%]`}>
        <div>
          <b>{props.title}</b>
          {props.subtitle && <em> ({props.subtitle})</em>}
        </div>
        {props.description && (
          <div>
            <em className="text-muted-foreground text-sm">{props.description}</em>
          </div>
        )}
      </div>
      <div role="cell" className={`${cellClass} min-[1000px]:flex-[1_0_calc(60%-50px)]`}>
        {props.children}
      </div>
    </div>
  );
};
